import { Box, Stack, Typography } from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";

import { checking_null_undefined } from "utils";

function ChargePointListTable(props: any) {

    const data = checking_null_undefined(props.chargePointData.properties.connectors);

    const columns: GridColDef[] = [
        {
            field: "connectorTypeAsString",
            renderHeader: () => (
                <Typography variant="subtitle2" fontWeight="bold">
                    {`Charge Point : ${props.chargePointData.properties.label}`}
                </Typography>
            ),
            sortable: false,
            width: 280,
            align: "left",
            headerAlign: "left",

        },
        {
            field: "ocppConnectorId",
            headerName: "Connector ID",
            sortable: false,
            width: 150,
            align: "center",
            headerAlign: "center",

        },
        {
            field: "rateKW",
            headerName: "Rate (KW)",
            sortable: false,
            width: 150,
            align: "center",
            headerAlign: "center",

        },
        {
            field: "status",
            headerName: "Connector Status",
            sortable: false,
            width: 150,
            align: "center",
            headerAlign: "center",

        },
        //    {
        //   field: "speed",
        //   headerName: "Speed",
        //   sortable: false,
        //   width: 150,
        //   align: "left",
        //   headerAlign: "center",
        // },

        // {
        //   field: "status",
        //   headerName: "Status",
        //   sortable: false,
        //   width: 150,
        //   align: "center",
        //   headerAlign: "center",
        // },
        // {
        //   field: "availability",
        //   headerName: "See Availability",
        //   sortable: false,
        //   width: 150,
        //   align: "right",
        //   headerAlign: "center",
        // },


    ];

    const CustomNoRowsOverlay = () => (
        <Stack height="100%" alignItems="center" justifyContent="center" p={2}>
            <Typography color="text.secondary">
                No Connectors have been configured.
            </Typography>
        </Stack>
    );

    const CustomNoResultsOverlay = () => (
        <Stack height="100%" alignItems="center" justifyContent="center" p={2}>
            <Typography color="text.secondary">
                Selected filter returned no results
            </Typography>
        </Stack>
    );

    return (
        <Box sx={{ width: '100%', p: 3 }}>
            <DataGrid
                rows={data}
                columns={columns}
                autoHeight
                getRowId={(row) => row.uuid}
                initialState={{
                    pagination: {
                        paginationModel: { pageSize: 15, page: 0 },
                    },
                }}
                pageSizeOptions={[15]}
                disableColumnMenu
                disableRowSelectionOnClick
                slots={{
                    noRowsOverlay: CustomNoRowsOverlay,
                    noResultsOverlay: CustomNoResultsOverlay,
                }}
                sx={{
                    '& .MuiDataGrid-cell': {
                        fontFamily: 'inherit'
                    },
                    '& .MuiDataGrid-columnHeaders': {
                        fontFamily: 'inherit'
                    }
                }}
            />
        </Box>
    );
}

export default ChargePointListTable;
